<template>
    <div>
        <confirm ref="confirm"></confirm>
        <v-overlay>
            <v-card light>
                <v-card-title>
                    {{$t("modify password")}}
                </v-card-title>
                <v-card-text>
                    <v-text-field v-model="password1" type="password" :label="$t('password')"/>
                    <v-text-field v-model="password2" type="password" :label="$t('password check')"/>
                    <v-chip outlined color="primary" v-if='this.text!=""'>
                        {{text}}
                    </v-chip>
                </v-card-text>
                <v-card-actions>
                    <v-btn elevation="20" class="white--text" color="#49a5ac" @click=save()><v-icon dense left>mdi-content-save-outline</v-icon>{{$t("modify password")}}</v-btn>
                    <v-btn elevation="20" class="white--text" color="#49a5ac" @click=cancel()><v-icon dense left>mdi-close</v-icon>{{$t("cancel")}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-overlay>
    </div>
</template>

<script>

import Api from "@/Api"
import { Utils } from "@/Utils"
import Confirm from "@/components/Confirm";

export default {
    components: {Confirm},

    data()
    {
        return {
            password1: "",
            password2: "",
            text: ""
        };
    },

    props: [],

    mixins: [Utils],

    created()
    {
    },

    methods:
    {
        cancel ()
        {            
            this.$router.go(-1);
            this.password1 = "";
            this.password2 = "";
            this.text = "";
        },
        save ()
        {
            if (this.password1 === "")
                this.text = this.$t("enter password");
            else if (this.password1 === this.password2)
            {
                const self = this;
                Api.changePassword(this.password1).then(function(result)
                {
                    if (result.status === 200)
                    {
                        self.$refs.confirm.open(self.$t("password changed"), {confirm:false}).then((confirm) =>
                        {
                            self.cancel();
                        });
                    }
                    else
                        self.text = self.$t("action not possible");

                })
                .catch((e) =>
                {                                        
                    self.text = self.$t("action not possible");
                });
            }
            else
                this.text = self.$t("no matching passwords");
        }
    }
};
</script>